import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { Envelope } from 'react-bootstrap-icons';
import useTheme from '@mui/styles/useTheme';
import { useTranslation } from 'react-i18next';
import ContactUsDrawer from '../../../components/ContactUsDrawer';
import { locales } from '../../../utils/formatters';
import useAuth from '../../../authentication/useAuth';

function OrderDetailContactCard({
	fullName,
	firstName,
	lastName,
	title,
	to,
	subject,
	message,
}) {
	const theme = useTheme();
	const { t } = useTranslation('common');
	const [contactUs, setContactUs] = useState(false);
	const { getCurrentUser } = useAuth();
	const user = getCurrentUser();
	const toDisplay = fullName && to ? `${fullName} (${to})` : fullName || to;

	function handleClick(e) {
		e.preventDefault();
		setContactUs(true);
	}

	return (
		<Grid item xs={12}>
			<Grid
				container
				item
				xs={12}
				style={{ marginTop: '1rem' }}
				role="paragraph"
				aria-label={t('contact_us')}
			>
				<Grid
					item
					xs={6}
					sm={4}
					md={5}
					role="paragraph"
					aria-label={t('contact_us')}
				>
					<Typography
						variant="heading8"
						role="paragraph"
						aria-label={t('contact_us')}
					>
						{t('contact_us')}
					</Typography>
				</Grid>
				<Grid
					item
					xs={6}
					sm={6}
					md={7}
					role="paragraph"
					aria-label={t('contact_us')}
				>
					<Grid
						item
						style={{
							paddingLeft: '.48rem',
							marginTop: '.032rem',
							cursor: 'pointer',
						}}
						role="paragraph"
						aria-label={fullName}
					>
						<Grid item xs={12} role="paragraph" aria-label={t('contact_us')}>
							<Envelope
								style={{
									color: theme.palette.link.main,

									fontWeight: '100',
									position: 'relative',
									fontSize: '1rem',
									margin: '0 .5rem -.12rem -2.4rem',
									cursor: 'pointer',
								}}
								data-testid="contact_drawer_envelope"
								onClick={handleClick}
								role="graphics-symbol"
								aria-hidden="true"
								aria-label={t('contact_us')}
							/>
							<Typography
								variant="subtitle3"
								role="paragraph"
								aria-label={fullName}
								onClick={handleClick}
								color={theme.palette.link.main}
								sx={{
									'&:hover': {
										textDecoration: 'underline',
									},
								}}
							>
								{fullName}
							</Typography>
						</Grid>

						<Grid
							item
							xs={12}
							role="paragraph"
							aria-label={t('contact_us')}
							sx={{ marginLeft: '-.87rem' }}
						>
							<Typography
								variant="body"
								role="paragraph"
								aria-label={title}
								onClick={handleClick}
							>
								{title}
							</Typography>
						</Grid>

						{contactUs === true && (
							<ContactUsDrawer
								isOpen
								from={user?.email}
								to={to}
								toDisplay={toDisplay}
								subject={subject}
								onClose={() => setContactUs()}
								locales={locales()}
								message={message}
								firstName={firstName}
								lastName={lastName}
							/>
						)}
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

OrderDetailContactCard.propTypes = {
	fullName: PropTypes.string,
	title: PropTypes.string,
	to: PropTypes.string,
	subject: PropTypes.string,
	message: PropTypes.string,
	firstName: PropTypes.string,
	lastName: PropTypes.string,
};

export default OrderDetailContactCard;
